<template>
    <div class="goods_line_bottom_box">
        <div class="goods_list_content B" v-if="listshow">
            <Row :gutter="20">
                <Col
                    class="goods_list_col"
                    span="24"
                    v-for="(item, index) in goodslist"
                    :key="index">
                    <div class="goods_list_box">
                        <div class="goods_list_img" :style="{backgroundImage: 'url('+item.det.img+')'}" @click="goto(item.goodsid)"></div>
                        <div class="goods_list_main">
                            <div class="goods_list_title">
                                <span>
                                    <b v-for="(lab, l) in item.det.lables" :key="l" v-if="item.det.lables.length > 0">{{lab}}</b>
                                    <b v-if="item.cxinfo.type == 1" style="background-color: #FF8000">特价</b>
                                    <b v-if="item.cxinfo.type == 2" style="background-color: #40a250">折扣</b>
                                    <span>{{item.det.name}}</span>
                                </span>
                            </div>
                            <div class="goods_list_fun_content">
                                <div class="goods_list_price_content">
                                    <div class="goods_list_price_left">
                                        <b>订货价：</b>
                                        <span v-if="!item.unitshow">￥{{item.cxinfo.is_cx == 1 ? item.cxinfo.cxcost : item.cost}}</span>
                                        <span v-else>￥{{item.cxinfo.is_cx == 1 ? ((item.cxinfo.cxcost * item.det.matrixing).toFixed(2)) : (item.cost * item.det.matrixing).toFixed(2)}}</span>
                                        <b>/{{item.unitshow ? item.det.maxunit : item.det.unit}}</b>
                                        <del v-if="item.cxinfo.is_cx == 1">（￥{{item.unitshow ? ((item.cxinfo.oldcost * item.det.matrixing).toFixed(2)) : item.cxinfo.oldcost}}/{{item.unitshow ? item.det.maxunit : item.det.unit}}）</del>
                                        <small>市场价{{item.unitshow ? ((item.market_cost * item.det.matrixing).toFixed(2)) : item.market_cost}}元/{{item.unitshow ? item.det.maxunit : item.det.unit}}</small>
                                    </div>
                                    <div class="goods_list_price_right">
                                        <span v-if="item.stock < item.det.minordernum && outstock <= 0">缺货</span>
                                        <!-- <span v-else-if="item.">缺货</span> -->
                                        <div class="goods_list_info" v-else>
                                            <span v-if="stockShow == 2">库存{{item.unitshow ? Math.floor((parseInt(item.stock)/parseInt(item.det.matrixing))) : item.stock}}{{item.unitshow ? item.det.maxunit : item.det.unit}}</span>
                                            <span>起订{{item.unitshow && item.det.minorderunit == 'unit' ? (Math.ceil(parseInt(item.det.minordernum)/parseInt(item.det.matrixing))) : item.det.minordernum}}{{item.unitshow ? item.det.maxunit : item.det.unit}}</span>
                                            <span v-if="item.det.doubleunit == 2">1{{item.det.maxunit}}={{item.det.matrixing}}{{item.det.unit}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="goods_list_gather_content">
                                    <div class="goods_list_gather_sign">
                                        <span class="goods_list_number">编号 {{item.det.commcode}} {{item.gg_attrname != null && item.gg_attrname != "" ? '规格：' + item.gg_attrname : ''}}</span>
                                        <div class="goods_list_gather_box" v-if="item.stock >= item.det.minordernum || outstock == 1">
                                            <div class="goods_list_num_content">
                                                <div class="goods_list_num">
                                                    <span @click="minBtn(item, item.det.minorderunit, item.det.minordernum, item.det.matrixing)">-</span>
                                                    <div class="goodsnum_select">
                                                        <InputNumber class="goodsnum" v-model="item.num" :min="0" @on-blur="goodsnumBlur(item, item.cxinfo, item.stock, item.det.minorderunit, item.det.minordernum, item.det.matrixing, item.det.maxunit, item.det.unit)"></InputNumber>
                                                        <i class="icon iconfont icon-xingzhuangjiehe" v-if="item.carcheck"></i>
                                                    </div>
                                                    <span @click="addBtn(item, item.cxinfo, item.stock, item.det.minorderunit, item.det.minordernum, item.det.matrixing, item.det.maxunit, item.det.unit)">+</span>
                                                </div>
                                                <Tooltip :content="item.unitshow ? item.det.maxunit : item.det.unit" theme="light" placement="top">
                                                    <div class="goods_list_unit" :style="{width: item.det.doubleunit == 1 || item.det.minorderunit == 'maxunit' ? '23px' : ''}" @click.stop="unitChange(item, item.cxinfo, item.stock, item.det.minorderunit, item.det.minordernum, item.det.matrixing, item.det.maxunit, item.det.unit, item.det.doubleunit)">
                                                        <span>{{item.unitshow ? item.det.maxunit : item.det.unit}}</span>
                                                        <i class="icon iconfont icon-xialazhankai" v-if="item.det.doubleunit == 2 && item.det.minorderunit == 'unit'"></i>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div class="goods_list_gwcbtn" @click.stop="addGoods(item, index)"><i class="icon iconfont icon-dianliang"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="goods_list_promotion" v-if="type == 0">
                                <span :style="{color: item.cxinfo.timestatus == 1 ? '#142672' : (item.cxinfo.timestatus == 2 ? '#FF8000' : '#999')}">{{item.cxinfo.timestatus == 1 ? '未开始' : (item.cxinfo.timestatus == 2 ? '进行中' : '已结束')}}</span>
                                <b>{{item.cxinfo.stime}}至{{item.cxinfo.etime}}</b>
                                <small v-if="item.cxinfo.personcount > 0">每人 限定{{item.unitshow ? Math.floor(parseInt(item.cxinfo.personcount)/parseInt(item.det.matrixing)) : item.cxinfo.personcount}}{{item.unitshow ? item.det.maxunit : item.det.unit}}</small>
                                <small v-if="item.cxinfo.availableamount > 0">促销数量剩余{{item.unitshow ? Math.floor(parseInt(item.cxinfo.availableamount)/parseInt(item.det.matrixing))  : item.cxinfo.availableamount}}{{item.unitshow ? item.det.maxunit : item.det.unit}}</small>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
        <noMsg v-if="notips"></noMsg>
        <Loadings v-if="loading"></Loadings>
        <!-- 分页 -->
        <div class="page_content">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
import noMsg from '@/components/component/nomsg.vue'
import Loadings from '@/components/component/loading.vue'
import {add, min, unitChange, numBlur} from '@/assets/js/addcart.js'
export default {
    props: ['type'],
    components: {noMsg, Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            outstock: 0, // 是否允许超库存购买 1 允许客户购买下单
            banorder: {}, // 是否禁止下单 error msg
            stockShow: 0, // 是否显示库存 1 不显示 2 显示
            tabsSign: 1, // 标签当选选中
            goodslist: [], // 商品列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息（商品促销）
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.promotion,
                {
                    timestatus: 4,
                    page: this.pagecurrent,
                    pagesize: this.pagesize
                }
            )
            .then(response => {
                console.log(response.data.msg)
                for (var i = 0; i < response.data.msg.goods_list.length; i++) {
                    response.data.msg.goods_list[i].num = 0
                    response.data.msg.goods_list[i].det.minorderunit == 'maxunit' ? response.data.msg.goods_list[i].unitshow = true : response.data.msg.goods_list[i].unitshow = false
                    // 是否加入购物车图标
                    response.data.msg.goods_list[i].carcheck = false
                }
                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    for (var j = 0; j < response.data.msg.goods_list.length; j++) {
                        if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_list[j].gg_id) {
                            response.data.msg.goods_list[j].num = this.$store.state.shopcartlist[i].num
                            response.data.msg.goods_list[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                            // 是否加入购物车图标
                            response.data.msg.goods_list[j].carcheck = true
                        }
                    }
                }
                this.goodslist = response.data.msg.goods_list
                // 是否显示库存
                this.stockShow = response.data.msg.depository_show
                // 是否允许超库存购买
                this.outstock = response.data.msg.depository_dinghuominus
                // 是否禁止购买
                this.banorder = response.data.msg.orderlimit
                this.pagetotal = response.data.msg.goods_pagecontent.num
                this.loading = false
                response.data.msg.goods_list.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        getReplenish () { // 获取商品列表&商品分页（最近购买的商品）
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.interestinglist,
                {
                    notestype: 1,
                    page: this.pagecurrent,
                    pagesize: this.pagesize,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                for (var i = 0; i < response.data.msg.goods_goodslist.length; i++) {
                    response.data.msg.goods_goodslist[i].num = 0
                    response.data.msg.goods_goodslist[i].det.minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].unitshow = true : response.data.msg.goods_goodslist[i].unitshow = false
                    // 是否加入购物车图标
                    response.data.msg.goods_goodslist[i].carcheck = false
                }
                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    for (var j = 0; j < response.data.msg.goods_goodslist.length; j++) {
                        if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].gg_id) {
                            response.data.msg.goods_goodslist[j].num = this.$store.state.shopcartlist[i].num
                            response.data.msg.goods_goodslist[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                            // 是否加入购物车图标
                            response.data.msg.goods_goodslist[j].carcheck = true
                        }
                    }
                }
                this.goodslist = response.data.msg.goods_goodslist
                // 是否显示库存
                this.stockShow = response.data.msg.depository_show
                // 是否允许超库存购买
                this.outstock = response.data.msg.depository_dinghuominus
                // 是否禁止购买
                this.banorder = response.data.msg.orderlimit
                this.pagetotal = response.data.msg.goods_pagecontent.num
                this.loading = false
                response.data.msg.goods_goodslist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        goto (id) { // 跳转详情页
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
        },
        minBtn (item, minorderunit, minordernum, matrixing) { // 减数量
            item.num = min(item, minorderunit, minordernum, matrixing)
        },
        addBtn (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit) { // 加数量
            item.num = add(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        goodsnumBlur (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit) { // 输入数量
            item.num = numBlur(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit) { // 切换大小规格
            let params = unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit, this.outstock)
            item.unitshow = params.unitshows
            item.num = params.nums
        },
        addGoods (item, index) { // 添加商品到购物车
            if (!this.banorder.error) { // 判断orderlimit.error是否限制下单
                if (item.num > 0) {
                    let newItem = [] // 添加到购物车的字段
                    newItem.push({
                        gg_id: item.gg_id, // 规格id
                        id: item.goodsid, // 商品id
                        is_det: item.is_det, // 商品id
                        num: item.num, // 商品数量
                        unitshow: item.unitshow, // 大小单位切换 false 小 true 大
                        remarks: '', // 备注信息
                    })

                    this.http.post(api.goodscheck,
                        {
                            gid: newItem[0].gg_id,
                            goodnum: newItem[0].num,
                            unitshow: newItem[0].unitshow,
                        }
                    )
                    .then(response => {
                        console.log(response.data.msg)
                        // 添加id购物车到缓存
                        this.$store.dispatch('addShopCartList', newItem)
                        // 添加成功提示
                        this.$Message.success('添加购物车成功')
                        // 已添加购物车标志
                        item.carcheck = true
                    })
                    .catch(error => {
                        this.$Message.error(error);
                    })
                } else {
                    this.$Message.warning('购买数量不能为0')
                }
            } else {
                // 弹出提示-限制原因
                this.$Message.warning(this.banorder.msg)
            }
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            if (this.type == 0) {
                this.getInfo()
            } else if (this.type == 1) {
                this.getReplenish()
            }
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            if (this.type == 0) {
                this.getInfo()
            } else if (this.type == 1) {
                this.getReplenish()
            }
        },
    },
    created () {
        if (this.type == 0) {
            this.getInfo()
        } else if (this.type == 1) {
            this.getReplenish()
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/promotion/goodslist.vue